<template>
  <div>
    <div class="row no-margin bgheaderpanel align-items-center slide-in" :class="{ extendSlider: showOtherInformationSlider }">
      <div class="bgclose" v-if="!showOtherInformationSlider">
        <div class="close-sidebar">
          <svgicon name="cancelwhite" width="11" height="11" :original="true"
            @click="closeSlideWindow"/>
        </div>
      </div>
      <div class="col no-padding">
        <div class="title">
          {{ $t('INVOICE_SUMMARY') }}
        </div>
      </div>
      <div class="col-md-auto no-padding" v-if="canGenerateFreightBillInvoice">
        <span v-if="isDifferentDrop">
          <Tooltip class="item" effect="dark" placement="bottom" popper-class="max-width">
            <div slot="content" class="tooltipcontent">
            {{ $t('PAY_INVALID_INDENT_SELECTION') }}
            </div>
              <span>
                <button class="btn section_pbtn" v-if="editable && !isInvoice" :disabled="disableGenerateInvoice || fetching"
                :class="{ disablebtn: disableGenerateInvoice || fetching }" @click="createInvoice()">
                   <span class="loadspin" v-show="fetching" :key="elementkey"></span>
                  {{ $t('GENERATE_INVOICE') }}
                </button>
              </span>
          </Tooltip>
        </span>
        <span v-else>
          <Tooltip v-if="isOverIndentLimit" class="item" effect="dark" placement="bottom" popper-class="max-width">
            <div slot="content" class="tooltipcontent">{{ overIndentLimitTooltip }}</div>
            <span>
              <button class="btn section_pbtn" v-if="editable && !isInvoice" :disabled="disableGenerateInvoice || fetching"
                :class="{ disablebtn: disableGenerateInvoice || fetching }" @click="createInvoice()">
                <span class="loadspin" v-show="fetching" :key="elementkey"></span>
                {{ $t('GENERATE_INVOICE') }}
              </button>
            </span>
          </Tooltip>
          <button v-else-if="editable && !isInvoice" class="btn section_pbtn" :disabled="disableGenerateInvoice || fetching"
            :class="{ disablebtn: disableGenerateInvoice || fetching }" @click="createInvoice()">
            <span class="loadspin" v-show="fetching" :key="elementkey"></span>
            {{ $t('GENERATE_INVOICE') }}
          </button>
        </span>
        <span>
          <button class="btn section_pbtn"
            v-if="!editable && $hasFeature('auto_generate_proforma_invoice_number') && !disableUpdateInvoice"
            :disabled="disableUpdateInvoice"
            :class="{ disablebtn: disableUpdateInvoice }" @click="updateInvoiceNumber()">
            <span class="loadspin" v-show="fetching" :key="elementkey"></span>
            {{ $t('UPDATE') }}
          </button>
        </span>
      </div>
      <div class="col-md-auto no-padding">
        <button class="btn section_pbtn" v-if="canCancel && !isFreightBill" :disabled="disableButton"
          :class="{ disablebtn: disableButton }" @click="cancelInvoice()">
          {{ $t('CANCEL') }}
        </button>
      </div>
      <div class="col-md-auto no-padding">
        <button class="btn section_pbtn" v-if="reSubmit" :disabled="disableReSubmit"
          :class="{ disablebtn: disableReSubmit }" @click="reSubmitInvoice()">
          {{ $t('RE_SUBMIT') }}
        </button>
      </div>
      <div class="col-md-auto no-padding">
        <button class="btn section_pbtn" v-if="(canSubmit && eInvoiceEnabled)"
        :class="{ disablebtn: disableVerify }" :disabled="disableVerify" @click="verifyInvoice()">
          {{ $t('INVOICE_VERIFY') }}
        </button>
      </div>
    </div>
    <Row class="d-flex">
      <Col>
        <SummaryHeader
          :isFreightBill="isFreightBill"
          :editable="editable"
          :values="headerValues"
          :clickedSubmit="clickedSubmit"
          :isNegativeInvoice="isNegativeInvoice"
          :isInvoice="isInvoice"
          :hsnSacList="hsnSacList"
          :editableBillParty="editableBillParty"
          :billToPartyValues="dropdownValues"
          :billToParty="billParty"
          :isAutoBillToPartyEnabled="isBillToPartyEnabled"
          :pastDay="pastDate"
          :status="(invoice && invoice.status)"
          :futureDay="futureDate"
          :isValiddate="isValidInvoiceDate"
          :centralHOEnabled="isCentralHOEnabled"
          :eInvoiceEnabled="eInvoiceEnabled"
          @updateValue="updateValue"
          @disableSubmit="disableSubmit"/>
        <div v-if="!isFreightBill">
          <Computation
            :isDedicatedTruck="isDedicatedTruck"
            :extraKm="getExtraKm"
            :isTaxable="isTaxable"
            :reSubmit="reSubmit"
            :editable="editable"
            :gstType="gstType"
            :isGstTypeConfigExist="isGstTypeConfigExist"
            :disableUpdateGST="disableUpdateGST"
            :isDefaultIgstExist="isDefaultIgstExist"
            :igst="igst"
            :invoiceCharges="invoiceCharges"
            :isIntraState="isIntraState"
            :isUnionTerritory="isUnionTerritory"
            :serviceProviderState="getServiceProviderState"
            :gstPercentageList="gstPercentageList"
            :gstNumber="getGstinNumber"
            :gstAckNo="getGstAckNumber"
            :gstAckDate="getGstAckDate"
            :clickedSubmit="clickedSubmit"
            :invoiceDate="invoiceDate"
            :billDiscountingConfig="billDiscountingConfig"
            :indentDetails ="indentDetails"
            :isInvoice="isInvoice"
            @updateValue="updateValue"
            @updateExtraKm="updateExtraKm"
            :showOtherInfoSlider="showOtherInformationSlider"
            :isEditableCustomFields="isEditableCustomFields"
            @openOtherInfoSlider="openOtherInfoSlider"
            v-if="editable && !isInvoice && paymentCount"/>
          <Computation
            :isDedicatedTruck="isDedicatedTruck"
            :extraKm="getExtraKm"
            :isTaxable="isTaxable"
            :reSubmit="reSubmit"
            :isInvoice="isInvoice"
            :editable="false"
            :invoiceStatusValue="getInvoiceStatus"
            :gstinEditable="editable"
            :gstAckNo="getGstAckNumber"
            :gstAckDate="getGstAckDate"
            :gstType="invoice.gst_type || 1"
            :disableUpdateGST="disableUpdateGST"
            :igst="getIgst"
            :invoiceCharges="invoiceCharges"
            :isIntraState="isIntraState"
            :isUnionTerritory="isUnionTerritory"
            :gstNumber="gstNumber"
            :paymentDueDate="invoice && invoice.payment_due_date"
            :invoiceDate="invoiceDate"
            :discount="invoice && invoice.discount_amount"
            :billDiscountingConfig="billDiscountingConfig"
            :serviceProviderState="(invoice.tax && invoice.tax.source) || ''"
            :clickedReSubmit="clickedReSubmit"
            :indentDetails ="indentDetails"
            @updateExtraKm="updateExtraKm"
            :isValiddate="isValidInvoiceDate"
            @updateValue="updateValue"
            v-else-if="isInvoiceLoaded"/>
          <ESingnature
            v-if="editable"
            :remark="remark"
            :attachmentsTransactionId="attachmentsTransactionId"
            @updateValue="updateValue"
          />
        </div>
        <div v-else>
          <Computation
            :isFreightBill="!!isFreightBill"
          />
        </div>
      </Col>
      <Col v-if="showOtherInformationSlider">
        <CustomFields
          ref="customFields"
          :customFields="customFields"
          @closeTab="closeOtherInfoSlider"
          @validationChange="updateCustomFieldsValidation"
        />
      </Col>
    </Row>
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import moment from 'moment';
import { cloneDeep, groupBy, isEmpty, uniqBy } from 'lodash';
import { invoice } from 'pando-payment-request-computation'; // TODO how to create an alias
import { gstType, gstSplitType, AdditionalChargesMethod, billToPartyTypes, movementMap, PaymentDiscountType, stateCodes, movementMapLowerForConfig, isUgstApplicable } from 'pando-constants';
import { BillToPartyValues, movementType, invoiceStatus, daysInMillis, defaultDateRange, confirmationMessage } from '@/constants/payments';
import SummaryHeader from './SummaryHeader';
import Computation from './Computation';
import ESingnature from './ESingnature';
import CustomFields from './CustomFIelds.vue';

export default {
  props: {
    attachmentsTransactionId: {
      type: String,
      default: () => '',
    },
    indentDetails: {
      type: Array,
      required: true,
      default: () => [],
    },
    editable: {
      type: Boolean,
      required: true,
    },
    invoice: {
      type: Object,
    },
    currentClientGstType: {
    },
    defaultIgst: {
      type: Number,
    },
    defaultGstDetails: {
      type: Object,
    },
    reSubmit: {
      type: Boolean,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    isTaxable: {
      type: Boolean,
    },
    paymentIds: {
      type: String,
    },
    isDedicatedTruck: {
      type: Boolean,
    },
    indentExtraKm: {
      type: Number,
      default: 0,
    },
    isFreightBill: false,
    freightBillId: null,
    freightBillDetails: {
      type: Object,
    },
    canSubmit: {
      type: Boolean,
      default: false,
    },
    eInvoiceEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SummaryHeader,
    Computation,
    ESingnature,
    CustomFields,
  },
  data() {
    return {
      hasDraftAttachments: false,
      fetching: false,
      elementkey: 2,
      extraKm: null,
      invoiceNumber: (this.invoice && this.invoice.invoice_number) || null,
      invoiceDate: (this.invoice && this.invoice.date && new Date(this.invoice.date)) || new Date(),
      billDate: new Date(),
      invoiceStatus,
      serviceProviderState: (this.defaultGstDetails && this.defaultGstDetails.name) || '',
      centralHOEnabled: false,
      igst: 0,
      remark: '',
      gstType: (this.defaultGstDetails && this.defaultGstDetails.gst_type != null ? this.defaultGstDetails.gst_type : null) || this.currentClientGstType || gstType.RCM,
      gstNumber: (this.defaultGstDetails && this.defaultGstDetails.number) || (this.invoice && this.invoice.gst_number) || '',
      gstAckNo: (this.defaultGstDetails && this.defaultGstDetails.ack_no) || (this.invoice && this.invoice.ack_no) || '',
      gstAckDate: (this.defaultGstDetails && this.defaultGstDetails.ack_date) || (this.invoice && this.invoice.ack_date) || '',
      hsnSac: (this.invoice && this.invoice.hsn_sac) || '',
      clickedSubmit: false,
      clickedReSubmit: false,
      billToParty: null,
      billToPartyId: '',
      sez: null,
      disableButton: false,
      BillToPartyValues,
      isDifferentDrop: false,
      billToPartyTypes,
      serviceRecipientState: false,
      payByDate: null,
      discountAmount: null,
      payEarly: false,
      minDiscountAmount: null,
      billToPartyAddress: null,
      billToPartyCity: null,
      billToPartyState: null,
      billToPartyGst: null,
      billToPartyPin: null,
      entityName: null,
      irnNumber: (this.invoice && this.invoice.irn_number) || null,
      isBillToPartyFilterEnabled: this.$hasFeature('bill_to_party_filter_in_invoice_flow'),
      showOtherInformationSlider: false,
      customFields: [],
      customFieldsValid: false,
      isEditableCustomFields: false,
      disableUpdateInvoice: true,
    };
  },
  async mounted() {
    this.igst = (this.defaultGstDetails && this.defaultGstDetails.percentage != null ? this.defaultGstDetails.percentage : null) || this.defaultIgst || 0;
    await this.centralHo();
    await this.getCustomFields();
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      currentTransporter: 'app/currentTransporter',
      transporterNonGst: 'app/transporterNonGst',
      totalAmountValue: 'paymentsV2/totalTransporterCharges',
      totalBaseFreight: 'paymentsV2/transporterTotalFreightCharge',
      currentClientConfig: 'app/currentClientConfig',
      paymentMovements: 'paymentsV2/paymentMovements',
      proformaInvoiceNumber: 'paymentsV2/proformaInvoiceNumber',
      selectedLegalEntity: 'paymentsV2/selectedLegalEntity',
    }),
    isLegalEntityBasedOnBillToParty() {
      return this.$hasFeature('legal_entity_based_on_bill_to_party') && this.selectedLegalEntity;
    },
    isEnableBillToPartyEntityName() {
      return this.currentClientConfig && this.currentClientConfig.enable_bill_to_party_entity_name;
    },
    getServiceProviderState() {
      return (this.defaultGstDetails && this.defaultGstDetails.name) || this.serviceProviderState || '';
    },
    getGstinNumber() {
      return (this.defaultGstDetails && this.defaultGstDetails.number) || (this.invoice && this.invoice.gst_number) || this.gstNumber || '';
    },
    getGstAckNumber() {
      return (this.defaultGstDetails && this.defaultGstDetails.ack_no) || (this.invoice && this.invoice.ack_no) || this.gstAckNo || '';
    },
    getGstAckDate() {
      return (this.defaultGstDetails && this.defaultGstDetails.ack_date) || (this.invoice && this.invoice.ack_date) || this.gstAckDate || '';
    },
    isCentralHOEnabled() {
      if (this.currentClientConfig.central_ho
        && this.billParty === 'Central HO'
      ) return true;
      return false;
    },
    getIgst() {
      if (this.invoice && this.invoice.initial_tax_snapshot && this.invoice.initial_tax_snapshot.tax) {
        return this.invoice.initial_tax_snapshot.tax.igst || 0;
      } else if (this.invoice && this.invoice.tax) {
        return this.invoice.tax.igst || 0;
      } return 0;
    },
    pastDate() {
      const startDay = this.dateRange.pastDays;
      const today = new Date();
      let dateVal = new Date(today.getTime() - ((startDay + 1) * daysInMillis));
      if (this.invoice && this.invoice.status === invoiceStatus.RETURNED) {
        if (dateVal.toISOString() < this.invoice.initial_invoice_action_date) {
          dateVal = this.invoice.initial_invoice_action_date;
          dateVal = new Date(dateVal);
          dateVal.setDate(dateVal.getDate() - 1);
        }
      } else if (this.indentDetails.length) {
        const oldest = this.indentDetails.reduce((d1, d2) =>
          (Date.parse(d2.delivered_date) > Date.parse(d1.delivered_date) ? d2 : d1));
        if (dateVal.toISOString() < oldest.delivered_date) {
          dateVal = oldest.delivered_date;
          dateVal = new Date(dateVal);
          dateVal.setDate(dateVal.getDate() - 1);
        }
      }
      return dateVal.toString();
    },
    isValidInvoiceDate() {
      const invoicegenerationDay = new Date(this.invoiceDate);
      const checkDay = new Date(this.pastDate);
      const isValid = (invoicegenerationDay.getTime() > checkDay.getTime());
      return isValid;
    },
    paymentCount() {
      return this.indentDetails && this.indentDetails.length;
    },
    disableVerify() {
      return !(this.isValidInvoiceDate && this.irnNumber && this.irnNumber.trim());
    },
    disableReSubmit() {
      if (this.isFreightBill) {
        return false;
      }
      return !(this.isValidInvoiceDate && !this.disableButton) || isEmpty(this.invoiceNumber.trim());
    },
    futureDate() {
      const startDay = this.dateRange.futureDays;
      const today = new Date();
      const dateVal = new Date(today.getTime() + (startDay * daysInMillis));
      return dateVal.toString();
    },
    dateRange() {
      const obj = {
      };
      const billDiscountConfig = this.billDiscountingConfig;
      if (billDiscountConfig && billDiscountConfig.is_enabled && billDiscountConfig.invoice_lower_limit
        && (this.totalAmountValue >= billDiscountConfig.invoice_lower_limit)) {
        obj.pastDays = 0;
      } else if (this.currentClientConfig.invoice_date_range) {
        if (this.currentClientConfig.invoice_date_range.past_days === 0) {
          obj.pastDays = 0;
        } else {
          obj.pastDays = this.currentClientConfig.invoice_date_range.past_days
            || defaultDateRange.pastDay;
        }
      } else {
        obj.pastDays = defaultDateRange.pastDay;
      }
      obj.futureDays = (
        this.currentClientConfig.invoice_date_range &&
        this.currentClientConfig.invoice_date_range.future_days
      ) || defaultDateRange.futureDay;
      return obj;
    },
    isNegativeInvoice() {
      return this.invoiceCharges && (this.invoiceCharges.totalAmount <= 0);
    },
    sourceState() {
      const depotDetails = (this.indentDetails && this.indentDetails[0] &&
        this.indentDetails[0].depot) || {};
      return depotDetails.le ? depotDetails.le.state : depotDetails.state;
    },
    destinationState() {
      const consigneeDetails = (this.indentDetails && this.indentDetails[0] &&
        this.indentDetails[0].consignee_data[0]) || {};
      return consigneeDetails.le ? consigneeDetails.le.state : consigneeDetails.state;
    },
    recipientState() {
      let state = null;
      const invoiceDestination = this.invoice && this.invoice.tax && this.invoice.tax.destination;
      if (this.billToPartyState) {
        state = this.billToPartyState;
      } else if (invoiceDestination) {
        state = invoiceDestination;
      } else if (this.$hasFeature('bill_to_party_in_material_invoice') && this.indentDetails.length) {
        const match = this.indentDetails.find(i => i.billToPartyDetails);
        if (match && match.billToPartyDetails && match.billToPartyDetails.state) {
          state = match.billToPartyDetails.state;
        }
      } else if (this.billParty) {
        if (['destination', 'source', 'Source Depot', 'Destination Depot'].includes(this.billParty)) {
          state = ['destination', 'Destination Depot'].includes(this.billParty) ? this.destinationState : this.sourceState;
        } else {
          const billToPartyValues = this.dropdownValues;
          const billToParty = billToPartyValues
            .find(billParty => billParty.label === this.billParty);
          state = billToParty ? billToParty.state : this.billParty;
        }
      }
      return state;
    },
    disableUpdateGST() {
      if (this.invoice && this.invoice.initial_tax_snapshot && this.reSubmit) {
        return true;
      }
      return false;
    },
    billParty() {
      if (this.isLegalEntityBasedOnBillToParty) {
        return this.selectedLegalEntity.client_legal_entity || this.selectedLegalEntity.company_name;
      }
      if (this.$hasFeature('legal_entity_based_on_bill_to_party')
        && this.invoice && this.invoice.bill_to_party_address && this.invoice.bill_to_party_address.name) {
        return this.invoice.bill_to_party;
      }
      if (this.$hasFeature('bill_to_party_in_material_invoice') && this.indentDetails.length) {
        const match = this.indentDetails.find(i => i.billToPartyDetails);
        if (match && match.billToPartyDetails) return match.billToPartyDetails.name;
      }
      if (!this.billToParty && this.invoice && this.invoice.bill_to_party) {
        if (this.billToPartyTypes.find(item => item.value === this.invoice.bill_to_party)) {
          this.billToParty = this.billToPartyTypes.find(item => item.value === this.invoice.bill_to_party).label;
        } else {
          this.billToParty = this.invoice && this.invoice.bill_to_party;
        }
      } else {
        // if both value's are undifened then call dropdownValues to set billToParty
        this.dropdownValues;
      }
      return (this.billToParty || 'Source Depot');
    },
    isBillToPartyEnabled() {
      return this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.auto_bill_to_party;
    },
    headerValues() {
      const obj = {};
      if (this.isFreightBill) {
        obj.billNumber = (this.freightBillDetails && this.freightBillDetails.bill_no) || '';
        obj.billDate = (this.invoice && this.invoice.date) || this.billDate;
      } else {
        this.extraKm = (this.extraKm !== null) ? this.extraKm : (this.invoice && this.invoice.extra_km);
        obj.serviceReciepentState = this.recipientState || (this.invoice && this.invoice.tax && this.invoice.tax.destination);
        obj.hsnSac = this.hsnSac || ((this.invoice && this.invoice.hsn_sac) || ((this.currentClient && this.currentClient.hsn_sac) || '--'));
        obj.poNumber = this.poNumber;
        // Reverse 'Yes' else 'No'.
        obj.isTaxReverseChargePayable = this.gstType === gstType.RCM ? 'Yes' : 'No';
        if (this.editable && !this.isInvoice) {
          obj.invoiceDate = this.invoiceDate || new Date(moment());
          obj.invoiceNumber = this.invoiceNumber;
        } else {
          obj.invoiceDate = this.invoiceDate || (this.invoice.date && new Date(this.invoice.date));
          obj.invoiceNumber = this.invoiceNumber;
        }
        let billParty = null;
        if (this.$hasFeature('legal_entity_based_on_bill_to_party')
          && this.invoice && this.invoice.bill_to_party_address && this.invoice.bill_to_party_address.name) {
          billParty = this.invoice.bill_to_party_address;
          obj.billToParty = this.invoice.bill_to_party;
          obj.billToPartyId = this.invoice.bill_to_party_id;
        } else if (this.$hasFeature('bill_to_party_in_material_invoice') && this.indentDetails.length
          && this.indentDetails.find(i => i.billToPartyDetails)) {
          const btp = this.indentDetails.find(i => i.billToPartyDetails).billToPartyDetails;
          billParty = btp;
          obj.billToParty = btp.name;
          obj.billToPartyId = btp.id;
        } else if (this.invoice && this.invoice.bill_to_party) {
          billParty = this.invoice.bill_to_party_address;
          obj.billToParty = this.invoice.bill_to_party;
          obj.billToPartyId = this.invoice.bill_to_party_id;
        } else if (!this.editableBillParty) { // if editablebilltoparty is not set, the value would be automated / pre-selected value.
          billParty = this.dropdownValues[0];
          obj.billToParty = this.dropdownValues[0] && this.dropdownValues[0].value;
          obj.billToPartyId = this.dropdownValues[0] && this.dropdownValues[0].billToPartyId;
        } else {
          obj.billToParty = this.billParty || 'Source Depot';
          billParty = this.dropdownValues.find(billParty => billParty.value === obj.billToParty);
          if (!billParty) {
            billParty = this.populateBillToPartyAddress(obj.billToParty);
          }
          obj.billToPartyId = billParty ? billParty.billToPartyId : '';
        }
        if (this.invoice && this.invoice.initial_tax_snapshot && this.reSubmit) {
          obj.igst = this.invoice.initial_tax_snapshot.tax.igst;
          obj.cgst = this.invoice.initial_tax_snapshot.tax.cgst;
        }
        obj.city = (this.billToPartyCity !== null) ? this.billToPartyCity : ((billParty && billParty.city) || '');
        obj.state = (this.billToPartyState !== null) ? this.billToPartyState : ((billParty && billParty.state) || '');
        obj.address = (this.billToPartyAddress !== null) ? this.billToPartyAddress : ((billParty && billParty.address) || '');
        obj.gst = (this.billToPartyGst !== null) ? this.billToPartyGst : ((billParty && billParty.gst) || '');
        obj.pincode = this.billToPartyPin || (billParty && billParty.pincode) || '';

        obj.sez = (this.sez !== null) ? this.sez : (this.invoice && this.invoice.sez_enabled);
        obj.irnNumber = (this.irnNumber);
        obj.isSezEnabled = (this.invoice && this.invoice.depot_sez_enabled) ||
          (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].sez_enabled);

        if (this.isLegalEntityBasedOnBillToParty) {
          obj.entityName = this.selectedLegalEntity.company_name;
          obj.address = this.selectedLegalEntity.address || '';
          obj.city = this.selectedLegalEntity.city || '';
          obj.state = this.selectedLegalEntity.state || '';
          obj.gst = this.selectedLegalEntity.gstin || '';
          obj.pincode = this.selectedLegalEntity.pincode || '';
          obj.billToParty = this.selectedLegalEntity.client_legal_entity || this.selectedLegalEntity.company_name;
        } else if (this.isEnableBillToPartyEntityName) {
          obj.entityName = (this.entityName !== null && this.entityName !== undefined) ? this.entityName :
            ((this.invoice && this.invoice.bill_to_party_address && this.invoice.bill_to_party_address.name) ||
            (billParty && billParty.companyName) || (billParty && billParty.name) || (this.invoice && this.invoice.bill_to_party && this.invoice.bill_to_party_address.name) ||
            (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name));
        } else {
          obj.entityName = (this.entityName !== null && this.entityName !== undefined) ? this.entityName :
            ((this.invoice && this.invoice.bill_to_party_address && this.invoice.bill_to_party_address.name) ||
            (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name));
        }

        obj.movement = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].movement;
        obj.invoiceStatus = this.invoice && this.invoice.status;
        obj.customStatus = this.invoice && this.invoice.custom_status;
        if (this.isBillToPartyFilterEnabled && !this.$hasFeature('bill_to_party_in_material_invoice') && this.indentDetails.length
          && this.indentDetails[0].bill_to_party && !this.billToParty && !window.location.pathname.includes('/v2/invoices')) {
          const billToPartyObj = this.dropdownValues.filter(item =>
            item.billToPartyId === this.indentDetails[0].bill_to_party)[0];
          obj.billToParty = (billToPartyObj && billToPartyObj.value) || obj.billToParty;
          obj.billToPartyId = (billToPartyObj && billToPartyObj.billToPartyId) || obj.billToPartyId;
          obj.city = billToPartyObj && billToPartyObj.city;
          obj.state = (billToPartyObj && billToPartyObj).state;
          obj.address = (billToPartyObj && billToPartyObj).address;
          obj.gst = (billToPartyObj && billToPartyObj).gst;
          obj.pincode = (billToPartyObj && billToPartyObj).pincode;
        }
        if (this.$hasFeature('auto_generate_proforma_invoice_number')) {
          const proformaInvoiceNumber = this.proformaInvoiceNumber ||
            (this.invoice && this.invoice.proforma_invoice_number);
          if (proformaInvoiceNumber) {
            if (this.editable) {
              obj.proformaInvoiceNumber = proformaInvoiceNumber;
              obj.invoiceNumber = proformaInvoiceNumber;
              this.invoiceNumber = proformaInvoiceNumber;
            } else {
              obj.proformaInvoiceNumber = this.invoice && this.invoice.proforma_invoice_number;
            }
          } else {
            obj.proformaInvoiceNumber = '--';
          }
        }
      }
      return obj;
    },
    currentClientGst() {
      if (this.currentTransporter && this.currentClient) {
        return this.currentTransporter.gst_details.find(
          gst => gst.client_id === this.currentClient.id,
        );
      }
      return undefined;
    },
    gstPercentageList() {
      if (this.currentClientGst && this.gstType === gstType.FCM) { // Forward currently selected
        const clientGstType = this.currentClientGst.type;
        if (clientGstType === gstType.RCM) { // ReverseToForward if config is REVERSE
          return this.transporterNonGst.igst_tax;
        }
        if (this.currentClientGst.percentage) {
          return [...new Set([this.currentClientGst.percentage].concat(
            this.transporterNonGst.igst_tax))];
        }
        return [...new Set([].concat(this.transporterNonGst.igst_tax))];
      }
      return [];
    },
    hsnSacList() {
      if (this.currentTransporter && this.currentTransporter.hsn_sac) { return [...this.currentTransporter.hsn_sac]; }
      return [];
    },
    additionalCharges() {
      if (this.invoice) {
        return this.invoice.additional_charges || [];
      } else if (this.currentClientGst) {
        const additionalChargesList = [];
        if (
          this.$hasFeature('transporter_payment_discount') &&
          this.currentClientGst.payment_discount
        ) {
          const movements = this.paymentMovements.reduce((acc, movement) => {
            acc.push(movementMap[movement].toLowerCase());
            return acc;
          }, []);
          // check if payments what movements exists in payments
          // for that movement if permission for movement is available then apply
          const type = (this.gstType === gstType.FCM) ? 'fcm' : 'rcm';
          const staticDiscountConfig = this.currentClientConfig && this.currentClientConfig.static_discounting;
          const discountType = staticDiscountConfig && staticDiscountConfig[type];
          const transporterPaymentDiscountConfig = (this.currentClientConfig.payment_settings
            && this.currentClientConfig.payment_settings.transporter_payment_discount_config);
          const enabledDiscountConfig = transporterPaymentDiscountConfig &&
            (Object.keys(transporterPaymentDiscountConfig).filter(movement =>
              transporterPaymentDiscountConfig[movement] && movements.includes(movement)));
          if (!transporterPaymentDiscountConfig ||
            (enabledDiscountConfig && enabledDiscountConfig.length)) {
            additionalChargesList.push({
              label: 'discount',
              type: (this.gstType === gstType.FCM && discountType) || PaymentDiscountType.TOTAL_BASE_VALUE,
              percentage: this.currentClientGst.payment_discount,
              method: AdditionalChargesMethod.SUBTRACT,
            });
          }
        }
        return additionalChargesList;
      }
      return [];
    },
    invoiceCharges() {
      return this.getInvoiceCharges();
    },
    isIntraState() {
      const stateCode = this.headerValues.gst && this.headerValues.gst.substring(0, 2);
      const states = stateCode ? stateCodes.filter(_state => _state.code === stateCode) : [];

      const recipientState = this.headerValues.serviceReciepentState ? [this.headerValues.serviceReciepentState.toUpperCase()] : [];
      const serviceRecipientState = states.length ?
        states.map(_state => _state.name) : recipientState;

      if (this.editable && !this.isInvoice) {
        return serviceRecipientState.includes(this.serviceProviderState.toUpperCase());
      } else if (this.invoice && this.invoice.tax) {
        return serviceRecipientState.includes(this.invoice.tax.source.toUpperCase());
      }
      return false;
    },
    isUnionTerritory() {
      if (!this.$hasFeature('ugst_support')) return false;
      const destination = this.headerValues.serviceReciepentState ||
        (this.invoice && this.invoice.tax && this.invoice.tax.destination);
      return this.isIntraState && isUgstApplicable(destination);
    },
    isGstTypeConfigExist() {
      return Object.values(gstType).includes(this.currentClientGstType);
    },
    isDefaultIgstExist() {
      return Boolean(this.defaultIgst);
    },
    billDiscountingConfig() {
      return this.currentClientConfig && this.currentClientConfig.bill_discounting;
    },
    getExtraKm() {
      let temp;
      if (this.extraKm >= 0) {
        temp = this.extraKm;
      } else if (this.invoice) {
        temp = this.invoice && this.invoice.extra_km;
      } else {
        temp = this.indentExtraKm;
      }
      return (temp ? Number(temp) : 0);
    },
    getInvoiceStatus() {
      return this.invoice.status;
    },
    canGenerateFreightBillInvoice() {
      let freightBillCheck = true;
      if (this.isFreightBill && this.freightBillDetails) {
        freightBillCheck = this.freightBillDetails.can_generate_invoice;
      }
      return freightBillCheck;
    },
    poNumber() {
      return (this.indentDetails && this.indentDetails.length
      && this.indentDetails[0] && this.indentDetails[0].po_number) || '--';
    },
    editableBillParty() {
      /**
       * Indents should be primary or vendor (depot-depot movements)
       * Single pickup and Single drop
       * Same source-destination combination
       */
      if (this.isLegalEntityBasedOnBillToParty) {
        return false;
      }
      if (this.$hasFeature('bill_to_party_in_material_invoice') && this.indentDetails.length
        && this.indentDetails.find(i => i.billToPartyDetails)) {
        return false;
      }
      let editable = true;
      if (this.indentDetails.length) {
        const destinationId = this.indentDetails[0].consignee_data[0].destination_location_id;
        const isAutomateBillToPartyEnabled = this.currentClientConfig.payment_settings &&
            this.currentClientConfig.payment_settings.auto_bill_to_party;
        const isSecondayMovement = this.indentDetails.every(indent => indent.movement === 1);
        /** if auto bill to party is
         *   enabled, bill to party will be source always for secondary movement
         *   irrespective of drop (single / multi) */
        if (isAutomateBillToPartyEnabled && isSecondayMovement) {
          return false;
        }

        const isSingleDrop = this.indentDetails.every((indent) => {
          if (indent.movement === movementType.PRIMARY || indent.movement === movementType.INWARD) {
            const destinationsBylocationId = groupBy(indent.consignee_data, 'destination_location_id');
            return Object.keys(destinationsBylocationId).length === 1;
          }
        });

        const isSameLocation = this.indentDetails.every(indent => (indent.movement === movementType.PRIMARY ||
        indent.movement === movementType.INWARD) && indent.consignee_data[0].destination_location_id === destinationId);

        // if single source & destination,
        //   auto bill to party is enabled then the field is not editable.
        if (isSingleDrop && isSameLocation && isAutomateBillToPartyEnabled) {
          editable = false;
        }

        if (isSingleDrop && !isSameLocation && isAutomateBillToPartyEnabled) {
          editable = false;
        }

        if (!isSingleDrop) {
          editable = true;
        }

        // editable in invoice returned status
        const validStatus = this.invoice ? this.invoice.status === invoiceStatus.RETURNED : true;

        return editable && validStatus;
      }
      return false;
    },
    getMultiDroDropDownValues() {
      const dropDownValues = [];
      const type = this.gstType === gstType.FCM ? 'fcm' : 'rcm';
      if (this.currentClientConfig.central_ho) {
        this.centralHoArray.forEach((centralHo) => {
          const hoDetails = centralHo[type];
          if (hoDetails) {
            dropDownValues.push({
              ...BillToPartyValues.find(billToParty => billToParty.value),
              billToPartyId: '',
              address: hoDetails.address,
              pincode: hoDetails.pincode,
              city: hoDetails.city,
              state: hoDetails.state,
              gst: hoDetails.gstin,
              label: centralHo.central_ho_name,
              value: centralHo.central_ho_name,
              companyName: hoDetails.company_name || centralHo.central_ho_name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name),
            });
          }
        });
      }
      const depot = this.indentDetails[0].depot && this.indentDetails[0].depot;
      dropDownValues.push({ ...BillToPartyValues.find(billToParty => billToParty.value === 'Source Depot'),
        billToPartyId: depot.source_location_id,
        ...this.getAddress(depot),
      });
      let id = 1;
      const destinations = [...new Set(this.indentDetails.flatMap(({ consignee_data }) => consignee_data))].sort();
      const destinationStates = uniqBy(destinations.map(destination => ({
        id: destination.destination_location_id,
        name: destination.name,
        ...this.getAddress(destination),
      })), 'name');
      const destinationDepots = destinationStates.map((consignee) => {
        const destination = {
          id: id + 1,
          value: consignee.name,
          label: consignee.name,
          billToPartyId: consignee.id,
          address: consignee.address,
          gst: consignee.gst,
          city: consignee.city,
          state: consignee.state,
          pincode: consignee.pincode,
          actualState: consignee.actualState,
          companyName: consignee.companyName,
        };
        id += 1;
        return destination;
      });
      dropDownValues.push(...destinationDepots);
      return dropDownValues;
    },
    single() {
      const destinationId = this.indentDetails[0].consignee_data[0].destination_location_id;
      return {
        aresingleDropIndents: this.indentDetails.every(indent => indent.consignee_data.length === 1),
        isSecondayMovement: this.indentDetails.every(indent => indent.movement === 1),
        autoBillToParty: this.currentClientConfig.payment_settings &&
          this.currentClientConfig.payment_settings.auto_bill_to_party,
        areSameDropIndents: this.indentDetails.every(indent =>
          indent.consignee_data[0].destination_location_id === destinationId),
      };
    },

    dropdownValues() {
      let billToPartyDropdownValues = [];
      if (this.indentDetails.length) {
      // if single drop
        const aresingleDropIndents = this.indentDetails.every(indent => indent.consignee_data.length === 1);
        const destinationId = this.indentDetails[0].consignee_data[0].destination_location_id;
        const areSameDropIndents = this.indentDetails.every(indent =>
          indent.consignee_data[0].destination_location_id === destinationId);
        const isPrimaryMovement = this.indentDetails.every(indent => indent.movement === 2);
        const isSecondayMovement = this.indentDetails.every(indent => indent.movement === 1);
        const movementType = this.indentDetails[0].movement;
        const isSingleMovement = this.indentDetails.every(indent => indent.movement === movementType);
        const autoBillToParty = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.auto_bill_to_party;
        const defaultBillPartyConfig = this.currentClientConfig && this.currentClientConfig.default_bill_to_party;
        const defaultBillPartyValue = movementMapLowerForConfig[this.indentDetails[0].movement];
        const defaultBillToParty = defaultBillPartyConfig ? defaultBillPartyConfig[defaultBillPartyValue] : null;

        if (!this.billToParty && !this.invoice && defaultBillToParty && isSingleMovement && !autoBillToParty) {
          const depot = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].depot;
          const defaultBillToPartyValuesSet = {
            1: [
              this.getSourceBillToPartyValues(BillToPartyValues[0].label, BillToPartyValues[0].value, depot.source_location_id, this.getAddress(depot)),
              ...this.getDestinationBillToPartyValues(aresingleDropIndents, areSameDropIndents),
            ],
            2: [
              ...this.getDestinationBillToPartyValues(aresingleDropIndents, areSameDropIndents),
              this.getSourceBillToPartyValues(BillToPartyValues[0].label, BillToPartyValues[0].value, depot.source_location_id, this.getAddress(depot)),
            ],
            3: [
              this.getSourceBillToPartyValues(BillToPartyValues[0].label, BillToPartyValues[0].value, depot.source_location_id, this.getAddress(depot)),
              ...this.getDestinationBillToPartyValues(aresingleDropIndents, areSameDropIndents),
            ],
          };
          billToPartyDropdownValues = defaultBillToPartyValuesSet[defaultBillToParty];
          if (this.currentClientConfig.central_ho) {
            const centralHoEntries = this.addCentralHo();
            if (centralHoEntries.length > 0) {
              if (defaultBillToParty === 3) {
                billToPartyDropdownValues.unshift(...centralHoEntries);
              } else {
                billToPartyDropdownValues.push(...centralHoEntries);
              }
            }
          }
          if (this.isBillToPartyFilterEnabled && this.indentDetails &&
            this.indentDetails.length > 0) {
            const targetBillToParty = this.indentDetails[0].bill_to_party;
            if (targetBillToParty) {
              const billToPartyIndex = billToPartyDropdownValues.findIndex(item =>
                item.billToPartyId === targetBillToParty,
              );
              if (billToPartyIndex > 0) {
                billToPartyDropdownValues.unshift(billToPartyDropdownValues.splice(billToPartyIndex, 1)[0]);
              }
            }
          }
          this.billToParty = billToPartyDropdownValues[0].value;
          this.billToPartyId = billToPartyDropdownValues[0].billToPartyId;
        } else {
          if (isSecondayMovement && autoBillToParty) {
            const depot = this.indentDetails[0].depot;
            billToPartyDropdownValues.push({ id: 1,
              label: BillToPartyValues[0].label,
              value: BillToPartyValues[0].value,
              billToPartyId: depot.source_location_id,
              ...this.getAddress(depot) });
          }
          if (aresingleDropIndents) {
            const consignee = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].consignee_data[0];
            const depot = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].depot;
            if (autoBillToParty && isPrimaryMovement) {
              // if movement is primary, the bill to party should be source.
              if (isPrimaryMovement) {
                billToPartyDropdownValues.push({ id: 1,
                  label: BillToPartyValues[1].label,
                  value: BillToPartyValues[1].value,
                  billToPartyId: consignee.destination_location_id,
                  ...this.getAddress(consignee) });
              }
              if (!areSameDropIndents) {
                this.isDifferentDrop = true;
                this.disableButton = true;
                billToPartyDropdownValues = [];
                billToPartyDropdownValues.push({ id: 1,
                  label: '--',
                  value: '--',
                  billToPartyId: '--' });
              }
              if (areSameDropIndents) {
                this.isDifferentDrop = false;
                this.disableButton = false;
                this.billToParty = billToPartyDropdownValues[0].value;
                this.billToPartyId = billToPartyDropdownValues[0].billToPartyId;

                this.serviceRecipientState = this.destinationState;
              }
            } else if (aresingleDropIndents && areSameDropIndents) {
              const type = this.gstType === gstType.FCM ? 'fcm' : 'rcm';
              const billToPartyValues = BillToPartyValues.filter((billToParyValues) => {
                if (billToParyValues.value === 'Central HO') {
                  if (
                    this.currentClientConfig.central_ho
                  ) return true;
                  return false;
                } return true;
              }).flatMap((billToParty) => {
                const billToPartyValue = cloneDeep(billToParty);
                const billPartyArray = [];
                if (billToPartyValue.value === 'Source Depot') {
                  billToPartyValue.billToPartyId = depot.source_location_id;
                  billPartyArray.push(depot.le || depot);
                } else if (
                  billToPartyValue.value === 'Central HO' &&
                    this.currentClientConfig.central_ho) {
                  this.centralHoArray.forEach((centralHo) => {
                    const hoDetails = centralHo[type];
                    if (hoDetails) {
                      const billToPartyClone = cloneDeep(billToPartyValue);
                      billToPartyClone.billToPartyId = '';
                      billToPartyClone.address = hoDetails.address;
                      billToPartyClone.city = hoDetails.city;
                      billToPartyClone.state = hoDetails.state;
                      billToPartyClone.gst = hoDetails.gstin;
                      billToPartyClone.pincode = hoDetails.pincode;
                      billToPartyClone.companyName = hoDetails.company_name || hoDetails.name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name);
                      billToPartyClone.label = centralHo.central_ho_name;
                      billPartyArray.push(billToPartyClone);
                    }
                  });
                } else {
                  billToPartyValue.billToPartyId = consignee.destination_location_id;
                  billPartyArray.push(consignee.le || consignee);
                }
                return billPartyArray.map((billParty) => {
                  const billToPartyResult = cloneDeep(billToPartyValue);
                  billToPartyResult.address = billParty.address;
                  billToPartyResult.city = billParty.city;
                  billToPartyResult.state = billParty.state;
                  billToPartyResult.gst = (billParty.value !== 'Source Depot' && billParty.value !== 'Destination Depot') ? billParty.gst : billParty.gstin;
                  billToPartyResult.pincode = billParty.pincode;
                  billToPartyResult.companyName = billParty.company_name || billParty.name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name);
                  if (billParty.label) {
                    billToPartyResult.value = billParty.label;
                    billToPartyResult.label = billParty.label;
                  }
                  return billToPartyResult;
                });
              });
              billToPartyDropdownValues.push(...billToPartyValues);
            } else if (aresingleDropIndents && !areSameDropIndents) {
              const multiDropvalues = this.getMultiDroDropDownValues;
              billToPartyDropdownValues = billToPartyDropdownValues.concat(multiDropvalues);
            }
          } else {
            const multiDropvalues = this.getMultiDroDropDownValues;
            billToPartyDropdownValues = billToPartyDropdownValues.concat(multiDropvalues);
          }
          if (this.isBillToPartyFilterEnabled) {
            this.getBillToPartyDetailsData(billToPartyDropdownValues);
          }
        }
      }
      return billToPartyDropdownValues;
    },
    isOverIndentLimit() {
      const maxIndentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice;
      if (!maxIndentsConfig || !this.paymentIds) return false;
      const paymentCount = this.paymentIds.split(',').filter(Boolean).length;
      const movement = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].movement;
      const movementKey = movement && movementMapLowerForConfig[movement];
      const limit = movementKey && maxIndentsConfig && maxIndentsConfig[movementKey];
      return !!(limit && limit > 0 && paymentCount > limit);
    },
    overIndentLimitTooltip() {
      const maxIndentsConfig = this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice;
      if (!maxIndentsConfig || !this.paymentIds) return '';
      const movement = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].movement;
      const movementKey = movement && movementMapLowerForConfig[movement];
      const limit = movementKey && maxIndentsConfig && maxIndentsConfig[movementKey];
      return limit ? `Cannot generate invoice with more than ${limit} indent${limit === 1 ? '' : 's'} for ${movementKey} movement` : '';
    },
    isInvoice() {
      return !!this.invoice;
    },
    isInvoiceLoaded() {
      return !isEmpty(this.invoice);
    },
    disableGenerateInvoice() {
      if (this.isOverIndentLimit) return true;
      let disable = !(this.invoiceNumber && this.serviceProviderState && this.gstNumber);
      if (this.payEarly && !disable) {
        disable = !(this.payByDate && this.discountAmount);
      }
      if (this.canGenerateFreightBillInvoice) {
        return this.isNegativeInvoice || this.disableButton || !this.customFieldsValid;
      }
      return disable || this.isNegativeInvoice || this.disableButton || !this.customFieldsValid;
    },
  },
  methods: {
    openOtherInfoSlider() {
      this.showOtherInformationSlider = true;
      this.$emit('extendSlider', true);
    },
    closeOtherInfoSlider() {
      this.showOtherInformationSlider = false;
      this.$emit('extendSlider', false);
    },
    async getCustomFields() {
      const result = await this.$store.dispatch('paymentsV2/getEditableCustomFields');
      if (result.custom_fields && result.custom_fields.length) {
        this.customFields = result.custom_fields;
        this.isEditableCustomFields = result.custom_fields.some(
          item => item.visible_to_transporter === true,
        );
        this.customFieldsValid = !result.custom_fields.some(
          item => (item.required && item.editable_to_transporter),
        );
      } else {
        this.customFieldsValid = true;
      }
    },
    async centralHo() {
      const result = await this.$store.dispatch('profile/getCentralHo');
      if (result.data) {
        this.centralHoArray = result.data;
      }
    },
    getInvoiceCharges() {
      const total = (this.payEarly && this.billDiscountingConfig && this.totalAmountValue >= this.billDiscountingConfig.invoice_lower_limit) ? (this.totalAmountValue - this.discountAmount) : this.totalAmountValue;
      let computeData = {};
      if (this.isTaxable) {
        let gstType = this.gstType;
        const isIntraState = this.isIntraState;
        let igst = this.igst;
        if (!this.editable && this.invoice) {
          gstType = this.invoice.gst_type;
          if (this.invoice.tax) {
            igst = this.getIgst;
          }
        }
        computeData = {
          tax: {
            igst,
            sgst: igst / 2,
            cgst: igst / 2,
          },
          additionalCharges: this.additionalCharges,
          total,
          baseFreight: this.totalBaseFreight,
        };
        const invoiceComputer = new invoice(computeData, gstType,
          isIntraState ? gstSplitType.INTRA_STATE : gstSplitType.INTER_STATE);
        return invoiceComputer.getTotal();
      }
      computeData = {
        additionalCharges: this.additionalCharges,
        total,
        baseFreight: this.totalBaseFreight,
      };
      const invoiceComputer = new invoice(computeData);
      return invoiceComputer.computeAdditioanlCharges();
    },
    populateBillToPartyAddress(billParty) {
      const billToPartyDetails = [];
      if (billParty.toLowerCase() === 'source depot') {
        const depot = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].depot;
        billToPartyDetails.push({
          address: depot.address,
          pincode: depot.pincode,
          city: depot.city,
          state: depot.state,
          gst: depot.gst,
          companyName: depot.company_name || depot.name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name),
        });
      } else if (billParty.toLowerCase() === 'central ho') {
        const type = this.gstType === gstType.FCM ? 'fcm' : 'rcm';
        this.centralHoArray.forEach((centralHo) => {
          const hoDetails = centralHo[type];
          if (hoDetails) {
            billToPartyDetails.push({
              address: hoDetails.address,
              pincode: hoDetails.pincode,
              city: hoDetails.city,
              state: hoDetails.state,
              gst: hoDetails.gstin,
              label: centralHo.central_ho_name,
              value: centralHo.central_ho_name,
            });
          }
        });
      }
      return billToPartyDetails.length > 0 ? billToPartyDetails : null;
    },
    canGenerateInvoice() {
      // FOR RCM transporter, GST Number is not mandatory
      const discounValidation = this.payEarly ? (this.payByDate && this.discountAmount && this.discountAmount < this.totalAmountValue && this.discountAmount >= this.minDiscountAmount) : true;
      return (this.invoiceNumber && this.getServiceProviderState &&
        (this.getGstinNumber || this.gstType === gstType.RCM) && discounValidation) ||
        (this.isFreightBill);
    },
    canReSubmitInvoice() {
      const discounValidation = this.payEarly ? (this.payByDate && this.discountAmount &&
        this.discountAmount < this.totalAmountValue && this.discountAmount >= this.minDiscountAmount) : true;
      return discounValidation || this.isFreightBill;
    },
    closeSlideWindow() {
      this.$emit('close');
    },
    toggle() {
      this.fetching = true;
    },
    toggleback() {
      this.fetching = false;
    },
    getBillToPartyAddress() {
      const result = this.headerValues;
      return {
        name: result.entityName,
        address: result.address,
        city: result.city,
        state: result.state,
        gst: result.gst,
        pincode: result.pincode,
      };
    },
    async confirmationBox(text) {
      return this.$PromptConfirm(text, 'Confirmation', {
        confirmButtonText: 'YES',
        cancelButtonText: 'NO',
        showCancelButton: true,
        lockScroll: true,
        showClose: false,
        center: true,
        disabled: this.fetching,
      });
    },
    async updateInvoiceNumber() {
      try {
        const data = {
          invoice_number: this.invoiceNumber,
          ...(this.invoiceDate && {
            invoice_date: new Date(this.invoiceDate).toISOString(),
          }),
        };
        const result = await this.$store.dispatch('paymentsV2/updateInvoice', {
          invoiceId: this.invoice.id,
          data,
        });
        if (result.error) {
          this.$errorMessage({ message: result.error });
        } else {
          this.$successMessage({ message: this.$getSuccess('INVOICE_UPDATE_SUCCESS') });
          this.$router.push({ name: 'invoices' });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('STATUS_UPDATE_FAILURE') });
      }
    },
    async createInvoice() {
      await this.confirmationBox(
        confirmationMessage.createInvoice,
      );
      this.toggle();
      try {
        this.$addGAEvent('Transporter - Pay', 'Click', 'Transporter - Pay: Invoice Submitted');
        this.clickedSubmit = true;
        if (this.canGenerateInvoice()) {
          let data;
          const customFields = this.$refs.customFields ? this.$refs.customFields.getValues() : null;
          if (this.isFreightBill) {
            data = {
              type: 2,
              freight_bill_id: this.freightBillId,
              invoice_date: this.billDate,
              gst_number: this.freightBillDetails && this.freightBillDetails.bill_no,
              invoice_amount: this.totalAmountValue,
              gst_type: 1,
              tax: {
                igst: 0,
                cgst: 0,
                sgst: 0,
                source: this.freightBillDetails && this.freightBillDetails.bill_no,
                destination: this.freightBillDetails && this.freightBillDetails.bill_no,
                intra_state: false,
              },
              extra_km: 0,
            };
          } else {
            const remark = this.remark.trim();
            data = {
              invoice_number: this.invoiceNumber,
              ...(this.$hasFeature('auto_generate_proforma_invoice_number')) ? {
                proforma_invoice_number: this.proformaInvoiceNumber,
              } : {},
              irn_number: this.irnNumber,
              ...(this.hsnSac ? { hsn_sac: this.hsnSac } : {}),
              invoice_date: new Date(this.invoiceDate).toISOString(),
              gst_number: this.getGstinNumber,
              ack_no: this.getGstAckNumber || null,
              ack_date: this.getGstAckDate ? new Date(moment(this.getGstAckDate)) : null,
              additional_charges: this.additionalCharges.length ? this.additionalCharges.map(
                charge => Object.assign({}, {
                  label: charge.label,
                  method: charge.method,
                  percentage: charge.percentage,
                  type: charge.type || PaymentDiscountType.TOTAL_BASE_VALUE,
                })) : undefined,
              payment_ids: this.paymentIds.split(','),
              invoice_amount: this.getInvoiceCharges().totalAmount,
              remark: remark.length ? remark : undefined,
              gst_type: this.gstType,
              tax: {
                source: this.getServiceProviderState,
                destination: this.recipientState,
                intra_state: this.isIntraState,
              },
              extra_km: this.extraKm ? Number(this.extraKm) : 0,
              initial_extra_km: this.indentExtraKm ? Number(this.indentExtraKm) : 0,
              bill_to_party: this.billToParty || 'Source Depot',
              sez_enabled: this.sez || false,
              pay_by_date: (this.payEarly && this.payByDate) ? new Date(this.payByDate).toISOString() : null,
              discount_amount: this.payEarly ? Number(this.discountAmount) : 0,
              bill_to_party_address: this.getBillToPartyAddress(),
              total_base_freight: this.totalBaseFreight,
              draft_attachment_transaction_id: this.hasDraftAttachments ? this.attachmentsTransactionId : '',
            };

            let id = this.billToPartyId || '';
            let billToParty = data.bill_to_party;
            if (this.isLegalEntityBasedOnBillToParty) {
              billToParty = this.selectedLegalEntity.client_legal_entity || this.selectedLegalEntity.company_name;
            } else if (!this.editableBillParty) {
              id = this.dropdownValues[0] && this.dropdownValues[0].billToPartyId;
              billToParty = this.dropdownValues[0] && this.dropdownValues[0].label;
            }
            data.bill_to_party_id = id;
            data.bill_to_party = billToParty;
            if (this.isTaxable) {
              data.tax = Object.assign({
                igst: this.igst,
                cgst: this.igst / 2,
                sgst: this.igst / 2,
              }, data.tax);
            } else {
              data.tax = Object.assign({
                igst: 0,
                cgst: 0,
                sgst: 0,
              }, data.tax);
            }
          }
          if (customFields) {
            data.customFields = customFields;
          }
          const result = await this.$store.dispatch('paymentsV2/createInvoice', data);
          if (result.error) {
            if (result.error === 'DUPLICATE_PROFORMA_INVOICE_NUMBER') {
              this.$errorMessage({ message: this.$getErr('PROFORMA_INVOICE_CREATE_FAILS') });
              this.$router.push({ name: 'payments' });
            } else {
              this.$errorMessage({ message: result.error });
            }
          } else {
            this.$successMessage({ message: this.$getSuccess('INVOICE_CREATION_SUCCESS') });
            this.$router.push({ name: 'invoices' });
          }
        }
        this.toggleback();
      } catch (error) {
        this.toggleback();
        console.log(error);
        this.$errorMessage({ message: this.$getErr('INVOICE_CREATION_FAILURE') });
      } finally {
        this.toggleback();
      }
    },
    updateValue(key, value, type) {
      if (!this.isFreightBill) {
        if (key === 'hsnSac') {
          this.hsnSac = value;
        } else if (key === 'gstType') {
          this.gstType = value;
        } else if (key === 'billToParty') {
          this.billToParty = value.billToParty;
          this.billToPartyId = value.billToParyId;
          this.billToPartyAddress = value.address;
          this.billToPartyCity = value.city;
          this.billToPartyState = value.state;
          this.billToPartyGst = value.gst;
          this.billToPartyPin = value.pincode;
          if (this.isEnableBillToPartyEntityName) {
            this.entityName = value.companyName || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name);
          }
          this.sez = false;
          this.disableButton = false;
        } else if (type === 'date') {
          this[key] = new Date(value);
        } else if (key === 'has_draft_attachments') {
          this.hasDraftAttachments = value;
        } else {
          this[key] = value;
        }
        if (!this.editable && this.$hasFeature('auto_generate_proforma_invoice_number') &&
          key === 'invoiceNumber') {
          this.disableUpdateInvoice = false;
        }
        // update tax based on sez flag
        if (key === 'sez') {
          if (this.sez) {
            this.igst = 0;
          } else {
            const statePercentage = this.defaultGstDetails && this.defaultGstDetails.percentage;
            this.igst = (statePercentage != null) ? statePercentage : this.defaultIgst;
          }
        }
        const data = {
          billToParty: this.billToParty || (this.invoice && this.invoice.bill_to_party),
          billToPartyId: this.billToPartyId || (this.invoice && this.invoice.bill_to_party_id),
          sez: (this.sez !== null) ? this.sez : (this.invoice && this.invoice.sez_enabled),
          igst: this.igst,
          recipientState: this.recipientState,
          isIntraState: this.isIntraState,
        };
        this.$emit('updateBillToParty', data);
      }
    },
    updateExtraKm(data) {
      if (data && Number(data) < 0) {
        this.extraKm = 0;
      } else {
        this.extraKm = data;
      }
      this.$emit('updateExtraKm', this.extraKm);
    },
    disableSubmit() {
      this.disableButton = true;
    },
    async verifyInvoice() {
      const result = await this.$store.dispatch('paymentsV2/verifyInvoice', { invoiceId: this.invoice.id, irnNumber: this.irnNumber, invoiceDate: this.invoiceDate });
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      } else {
        this.$successMessage({ message: this.$getSuccess('INVOICE_VERIFIED') });
        this.$router.push({ name: 'invoices' });
      }
    },
    async reSubmitInvoice() {
      await this.confirmationBox(
        confirmationMessage.reSubmitInvoice,
      );


      this.clickedReSubmit = true;
      if (this.canReSubmitInvoice()) {
        const billToPartyValues = this.dropdownValues;
        const billToParty = billToPartyValues.find(billParty => billParty.label === this.billParty);
        const billToPartyValue = billToParty ? billToParty.value : this.billParty;
        const billToPartyId = billToParty ? billToParty.billToPartyId : '';
        const data = {
          bill_to_party: billToPartyValue,
          bill_to_party_id: billToPartyId,
          invoice_date: this.invoiceDate,
          ...(this.hsnSac ? { hsn_sac: this.hsnSac } : {}),
          gst_number: this.gstNumber,
          extra_km: this.extraKm ? Number(this.extraKm) : 0,
          invoice_number: this.invoiceNumber,
          irn_number: this.irnNumber,
          invoice_amount: this.invoiceCharges.totalAmount,
          pay_by_date: (this.payEarly && this.payByDate) ? new Date(this.payByDate).toISOString() : null,
          discount_amount: this.payEarly ? Number(this.discountAmount) : 0,
          bill_to_party_address: this.getBillToPartyAddress(),
        };
        if (data.invoice_number === '') {
          alert('Invoice Number is null!');
        }
        this.$emit('statusUpdate', 're_submitted', data);
      }
    },
    cancelInvoice() {
      this.$emit('openRemarks');
    },
    getAddress(data) {
      const item = data.le || data;
      const companyName = item.company_name || item.name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name) || null;
      return {
        address: item.address,
        gst: item.gst,
        city: item.city,
        state: item.state,
        pincode: item.pincode,
        companyName,
        actualState: data.state,
      };
    },
    getSourceBillToPartyValues(label, value, billToPartyId, addressData) {
      return {
        label,
        value,
        billToPartyId,
        ...addressData,
      };
    },
    getBillToPartyDetailsData(dropDownValues) {
      if (this.isBillToPartyFilterEnabled) {
        const billToPartyDetails = this.indentDetails &&
         this.indentDetails.length > 0 && this.indentDetails[0].billToPartyDetails ?
          this.indentDetails[0].billToPartyDetails : {};
        if (Object.keys(billToPartyDetails).length > 0) {
          const billToPartyObj = {
            label: billToPartyDetails.name,
            value: billToPartyDetails.name,
            billToPartyId: billToPartyDetails.id,
            address: billToPartyDetails.address,
            gst: billToPartyDetails.gst,
            city: billToPartyDetails.city,
            state: billToPartyDetails.state,
            pincode: billToPartyDetails.pincode,
            actualState: billToPartyDetails.actualState,
            companyName: billToPartyDetails.companyName || billToPartyDetails.name,
          };
          dropDownValues.push(billToPartyObj);
        }
      }
    },
    getDestinationBillToPartyValues(aresingleDropIndents, areSameDropIndents) {
      const dropDownValues = [];
      if (aresingleDropIndents && areSameDropIndents) {
        const consignee = this.indentDetails && this.indentDetails[0] && this.indentDetails[0].consignee_data[0];
        dropDownValues.push({
          label: BillToPartyValues[1].label,
          value: BillToPartyValues[1].value,
          billToPartyId: consignee.destination_location_id,
          ...this.getAddress(consignee),
        });
        if (this.isBillToPartyFilterEnabled) {
          this.getBillToPartyDetailsData(dropDownValues);
        }
        return dropDownValues;
      }

      const destinations = [...new Set(this.indentDetails.flatMap(({ consignee_data }) => consignee_data))].sort();
      const destinationStates = uniqBy(destinations.map(destination => ({
        id: destination.destination_location_id,
        name: destination.name,
        ...this.getAddress(destination),
      })), 'name');
      const destinationDepots = destinationStates.map((consignee) => {
        const destination = {
          label: consignee.name,
          value: consignee.name,
          billToPartyId: consignee.id,
          address: consignee.address,
          gst: consignee.gst,
          city: consignee.city,
          state: consignee.state,
          pincode: consignee.pincode,
          actualState: consignee.actualState,
          companyName: consignee.companyName,
        };
        return destination;
      });

      dropDownValues.push(...destinationDepots);
      if (this.isBillToPartyFilterEnabled) {
        this.getBillToPartyDetailsData(dropDownValues);
      }
      return dropDownValues;
    },
    addCentralHo() {
      const type = this.gstType === gstType.FCM ? 'fcm' : 'rcm';
      const centralHoArray = this.centralHoArray;
      if (this.currentClientConfig.central_ho && centralHoArray && centralHoArray.length > 0) {
        return centralHoArray.map((centralHo) => {
          const hoDetails = centralHo[type];
          return {
            label: centralHo.central_ho_name,
            value: centralHo.central_ho_name,
            billToPartyId: '',
            address: hoDetails.address,
            city: hoDetails.city,
            state: hoDetails.state,
            gst: hoDetails.gstin,
            pincode: hoDetails.pincode,
            companyName: hoDetails.company_name || centralHo.central_ho_name || (this.indentDetails && this.indentDetails[0] && this.indentDetails[0].client_name),
          };
        });
      }
      return [];
    },
    updateCustomFieldsValidation(isValid) {
      // console.log('----emit', isValid)
      this.customFieldsValid = isValid;
    },
  },
  watch: {
    invoice(newVal) {
      this.gstNumber = newVal.gst_number;
      this.hsnSac = newVal.hsn_sac;
      this.invoiceDate = newVal && newVal.date && new Date(newVal.date);
      this.invoiceNumber = newVal && newVal.invoice_number;
      this.irnNumber = newVal && newVal.irn_number;
    },
  },
};
</script>
<style lang="scss">
  .disablebtn {
    cursor: not-allowed
  }
</style>
